import { DatasetReviewDto, StudyReviewDto } from '@interfaces/central-monitoring';
import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import { getData, postData, ValidationErrorResponse } from '@apis/rest-client';

const endpoints = {
    getAll: (studyId: string) => `CentralMonitoring/DatasetReview/${studyId}`,
};
const DatasetReviewsApi = {
    useGet: (studyRef: string, datasetId: number | undefined) => {
        const url = datasetId ? `CentralMonitoring/DatasetReview/${studyRef}/${datasetId}` : null;

        return useSWR<DatasetReviewDto, ValidationErrorResponse>(url, getData);
    },

    useGetAll: (studyRef: string) => {
        return useSWR<StudyReviewDto[], ValidationErrorResponse>(endpoints.getAll(studyRef), getData);
    },
    invalidateGetAll: (studyRef: string) => {
        return mutate(endpoints.getAll(studyRef));
    },

    useGetPreviousReviewedDatasetIds: (studyRef: string, datasetId: number | undefined) => {
        const url = datasetId
            ? `CentralMonitoring/DatasetReview/${studyRef}/${datasetId}/previous-reviewed-datasets`
            : null;

        return useSWR<number[]>(url, getData);
    },

    useSave: (studyRef: string, datasetId: number) => {
        return useSWRMutation(
            `CentralMonitoring/DatasetReview/${studyRef}/${datasetId}`,
            (url: string, { arg }: { arg: DatasetReviewDto }) => {
                return postData<DatasetReviewDto, NonNullable<unknown>>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default DatasetReviewsApi;
